import { 
    SET_VARIABLE_FIELDS,
    SET_API_CLIENT_PAYLOAD,
    ADD_REQUEST_PARAMETER,
    REMOVE_REQUEST_PARAMETER,
    ONCHANGE_HANDLER,
    ADD_UPDATE_API_COLLECTION,
    REMOVE_API_COLLECTION,
    SET_SELECTED_COLLECTION,
    SET_API_RESPONSE,
    SET_RELATED_WINDOW_FIELDS,
    SET_DEFAULT_CONTENT_TYPE,
    SET_AUTO_MAPPING_FIELDS,
    SET_FORMULA_FIELD_DATA,
    SET_VARIABLES_PAYLOAD,
    SET_MAPPING_FIELD_DATA,
    SET_AUTO_MAPPING_FILTERED_FIELDS,
    SET_ARRAY_OBJECT_FIELDS,
    SET_WINDOW_FIELDS,
    SET_INPUT_VARIABLES
} from "../actionTypes/ApiClientActionTypes";
import {isSet,getQueryVariable} from '../../Utils/CommonFunctions';

//SET DETAILS PAYLOAD
export const setApiCollectionAction = (payload) => {
    return { 
      type: SET_API_CLIENT_PAYLOAD, 
      payload:payload
    };
};
export const updateInputValuesPayloadAction = (payload)=>{
  return{
    type:SET_INPUT_VARIABLES,
    payload:payload
  }
}
export const setVariableFieldsAction = (obj) =>{
  return{
    type:SET_VARIABLE_FIELDS,
    payload:obj
  }
}
export const setAutoMappingFieldsAction = (obj)=>{
  return {
    type:SET_AUTO_MAPPING_FIELDS,
    payload:obj
  }
}

export const setAutoMappingFilteredFieldsAction = (obj)=>{
  return {
    type:SET_AUTO_MAPPING_FILTERED_FIELDS,
    payload:obj
  }
}
//
export const setVariablesPayloadAction = (obj)=>{
  return {
    type:SET_VARIABLES_PAYLOAD,
    payload:obj
  }
}

export const setMappingFieldDataAction = (obj)=>{
  return {
    type:SET_MAPPING_FIELD_DATA,
    payload:obj
  }
}

export const setFormulaFieldDataAction = (obj)=>{
  return {
    type:SET_FORMULA_FIELD_DATA,
    payload:obj
  }
}

export const addNewRequestParamAction = (reqIndex,paramName) => {
    return { 
      type: ADD_REQUEST_PARAMETER, 
      payload:{
        reqIndex:reqIndex,
        paramName:paramName
      }
    };
};


export const removeRequestParamAction = (reqIndex,reqParamIndex,paramName) => {
  return { 
    type: REMOVE_REQUEST_PARAMETER, 
    payload:{
      reqIndex:reqIndex,
      paramName:paramName,
      reqParamIndex:reqParamIndex
    }
  };
};

export const onChangeHandlerAction = (obj,val,keys,type='others') => {
  return { 
    type: ONCHANGE_HANDLER, 
    payload:{
      type:type,
      obj:obj,
      keys:keys,
      isInsertExp:false,
      selectedValue:val
    }
  };
};

export const setContentTypeHeaders = (reqIndex,type) => {
  return { 
    type: SET_DEFAULT_CONTENT_TYPE, 
    payload:{
      type:type,
      reqIndex:reqIndex
    }
  };
};


export const addNewCollectionAction = (action,obj) => {
  return { 
    type: ADD_UPDATE_API_COLLECTION, 
    payload:{
      actn:action,
      collectionObj:obj
    }
  };
};


export const removeCollectionAction = (reqIndex) => {
return { 
  type: REMOVE_API_COLLECTION, 
  payload:{
    reqIndex:reqIndex,
  }
};
};
export const setSelectedCollection = (selectedId,hisIndex=null)=>{
  return{
    type:SET_SELECTED_COLLECTION,
    payload:{selectedId:selectedId,hisIndex:hisIndex}
  }
}

export const setApiResponseAction = (responseType,reqIndex,responseData,isSideBarOpen=true)=>{
  return{
    type:SET_API_RESPONSE,
    payload:{
      responseType:responseType,
      isSideBarOpen:isSideBarOpen,
      responseData:responseData,
      reqIndex:reqIndex
    }
  }
}

export const setRelatedWindowFields = (obj)=>{
  return{
    type:SET_RELATED_WINDOW_FIELDS,
    payload:{
      relatedWindowFields:obj
    }
  }
}
export const setArrayObjectVariablesAction = (varId,fields)=>{
  return{
    type:SET_ARRAY_OBJECT_FIELDS,
    payload:{
      varId:varId,
      fields:fields
    }
  }
}

export const setWindowFieldsAction = (winId,winFields)=>{
  return{
    type:SET_WINDOW_FIELDS,
    payload:{
      winId:winId,
      winFields:winFields
    }
  }
}


export const insertFieldsExpression = (object,val)=>{
  // console.log('isSet(obj.reqIndex,null)',isSet(obj.reqIndex,null));
  const {keys,obj} = object;
  let bodyType = isSet(isSet(keys,{bodyType:''}).bodyType,'');
  // const {bodyType} = keys;
  if(isSet(object.type,null)===null){
    return { 
      type: '', 
      payload:{
      }
    };
  }
  let updatedValue = '';
  let selectedValue = isSet(object.selectedValue,'');
  if(obj==="request_body"){
    if(bodyType==='FORM'){
      const {query} = getQueryVariable('?'+selectedValue[bodyType]);
      query.forEach((itm,itmIndex)=>{
        if(itmIndex===keys.index){
          selectedValue =(keys.keyType==='value')?itm.value:itm.key;
        }
      })
    }else{
      selectedValue = selectedValue[bodyType];
    }
  }
  try{
    let arrGivenString = [...selectedValue];
    arrGivenString.splice(isSet(keys.position,selectedValue.length-1), 0, val);
    updatedValue  = arrGivenString.join('');
  }catch(e){

  }
  if(obj==="request_body"){
    if(bodyType==='FORM'){
      // let dataCnt = 0;
      // let formData = new FormData(); 
      const {query} = getQueryVariable('?'+object.selectedValue[bodyType]);
      let formData = [];
      query.forEach((itm,itmIndex)=>{
        let keyValue = itm.value;
        let key = itm.key;
        if(itmIndex===keys.index){
          if(keys.keyType!=='value'){
            key = updatedValue
          }else if(keys.keyType==='value'){
            keyValue = updatedValue
          }
        }
        formData.push(key+'='+keyValue);
      })
      updatedValue = formData.join('&');
    }
    updatedValue = {
      ...object.selectedValue,
      [bodyType]:updatedValue
    };
  }
  return { 
    type: ONCHANGE_HANDLER, 
    payload:{
      ...object,
      isInsertExp:true,
      selectedValue:updatedValue
    }
  };
}
//addNewQueryStringAction
